import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Chip, Avatar } from '@mui/material';
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import VideoChatRoundedIcon from "@mui/icons-material/VideoChatRounded";
import AlternateEmailRoundedIcon from "@mui/icons-material/AlternateEmailRounded";
import StickyNote2RoundedIcon from "@mui/icons-material/StickyNote2Rounded";
import Tooltip from "@mui/material/Tooltip";
import NotificationAddRoundedIcon from "@mui/icons-material/NotificationAddRounded";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import { styled } from '@mui/system';
import cardimg from "../../Assets/img/icons/icons8-bank-cards 1.svg";
import whatsapp from "../../Assets/img/icons/whatsapp.svg";
// import linkedin from "../../Assets/img/icons/linkedin.svg";
// import insta from "../../Assets/img/icons/instagram.svg";
// import facebook from "../../Assets/img/icons/icons8-facebook.svg";
// import twitter from "../../Assets/img/icons/twitter.svg";
// import youtube from "../../Assets/img/icons/youtube.svg";
// import facebookmessenger from "../../Assets/img/icons/facebook-messenger 1.svg";
// import messenger from "../../Assets/img/icons/messenger.svg";
// import tumblr from "../../Assets/img/icons/tumblr.svg";
// import dribble from "../../Assets/img/icons/dribbble 1.svg";
// import discord from "../../Assets/img/icons/discord.svg";
import calendar from "../../Assets/img/icons/calendar.svg";
import person1 from "../../Assets/img/person1.svg";
import person2 from "../../Assets/img/person2.svg";
import person3 from "../../Assets/img/person3.svg";
import person4 from "../../Assets/img/person4.svg";
import chatbot from "../../Assets/img/chatbot.svg";
import defaultprofile from '../../Assets/img/Default-Profile.jpg'

import { ReactComponent as LinkedinIcon } from "../../Assets/img/icons/linkedin.svg"
import { ReactComponent as FacebookIcon } from "../../Assets/img/icons/facebook-messenger 1.svg"
import { ReactComponent as WhatsappIcon } from "../../Assets/img/icons/whatsapp.svg"
import { ReactComponent as InstagramIcon } from "../../Assets/img/icons/instagram.svg"
// import axios from "axios";
import QRCode from "qrcode.react";
import axios from 'axios';
import useAvailableHeight from "../Custom/UseAvailableHeight";
// import NeoinScan from "../../Assets/img/icons/Neoin-at-center.svg";
// import companylogo from "../../Assets/img/icons/Company-logo.svg";
// // import profile from "../../Assets/img/icons/User-Profile-Pic.svg";
// import NeoinQR from "../../Assets/img/icons/QR-with-Neoin.svg";
// import QrcodeScan from "../../Assets/img/icons/QRcode Scanner.svg";
// // import frame from "../../Assets/img/upload-image.png"
// import DefaultProfile from "../../Assets/img/Default-Profile.png"
import MapIntegration from "./Mapintegration";
import { useUserDetailContext } from '../UserDetailContext';
import { getIconAndLabel } from '../Utilities/SocialMediaMapping'
import { ContactsDetContext } from '../ContactsDetContext';
import useApi from "../Utilities/useAPI";
import { useSelector } from "react-redux";

const HomePage = () => {
  const apiKey = process.env.REACT_APP_API_KEY;
  const { userDetails, setFavoriteCards, setUserDetails, setCards, groupCardDetails, cards, localStoreUserDetails } = useUserDetailContext();
  // const { favouriteContacts } = useContext(ContactsDetContext);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // console.log("param user", userDetails);
  let objectId = searchParams.get("objectId");
  // console.log("search param objectid", objectId);
  const [ConnectedContacts, setConnectedContacts] = useState([]);
  const [unVerifiedCount, setUnVerifedCount] = useState([]);
  const [UnverifiedContacts, setUnverifiedContacts] = useState([]);
  const [favouriteContacts, setFavoriteContacts] = useState([]);
  const apiFetching = useRef(false);
 
  // console.log("USERDETAILS INFO INSIDE THE HOME PAGE", localStoreUserDetails);


  if (!objectId) {
    // If objectId is not found in URL params, try to get it from localStorage
    objectId = localStorage.getItem('objectId');
  } else {
    // If objectId is found in URL params, set it in localStorage
    localStorage.setItem('objectId', objectId);
  }

  const [availableHeight1, Column1Ref] = useAvailableHeight(155);

  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${objectId}`
  };

  const { callApiFunction } = useApi();
  // if (userDetails.name == "FirstName LastName") {


  //   const fetchUserProfile = async () => {
  //     if (apiFetching.current) return;
  //     apiFetching.current = true;

  //     try {
  //       if (!objectId) {
  //         // alert("Object ID is not available");
  //         return;
  //       }

  //       const UserDetails = localStorage.getItem(userDetails);

  //       try {
  //         const userResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mail/user`, {
  //           headers: headers
  //         });
  //         const userData = userResponse.data;
  //         localStorage.setItem("userDetails", JSON.stringify(userData));

  //         const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/card-details`, {
  //           headers: headers
  //         });

  //         const data = await response.data;

  //         const uniqueCardNames = [...new Set(data.map(card => card.card_name))];
  //         setCards(uniqueCardNames);

  //         const favoriteCardNames = data.filter(card => card.is_favourite === 1).map(card => card.card_name);
  //         setFavoriteCards(favoriteCardNames);

  //       } catch (error) {
  //         console.error('Error fetching User All card details:', error);
  //       }

  //     } catch (error) {
  //       console.error("Error details:", error.response);
  //     }
  //   };
  //   fetchUserProfile();
  // }


  useEffect(() => {
    const fetchUserProfile = async () => {
      if (apiFetching.current || userDetails.name !== "FirstName LastName") return;

      if (!objectId) {
        console.warn("Object ID is not available");
        return;
      }

      apiFetching.current = true;

      try {
        const storedUserDetails = localStorage.getItem("userDetails");
        if (!storedUserDetails) {
          const userResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}api/v1/mail/user`, {
            headers,
          });
          const userData = userResponse.data;
          localStorage.setItem("userDetails", JSON.stringify(userData));
        }

        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/card-details`, {
          headers,
        });

        const data = response.data;

        const uniqueCardNames = [...new Set(data.map((card) => card.card_name))];
        setCards(uniqueCardNames);

        const favoriteCardNames = data.filter((card) => card.is_favourite === 1).map((card) => card.card_name);
        setFavoriteCards(favoriteCardNames);
      } catch (error) {
        console.error("Error fetching user profile or card details:", error);
      } finally {
        apiFetching.current = false;
      }
    };

    fetchUserProfile();
  }, [userDetails.name, objectId]); // Only trigger on changes to `userDetails.name` or `objectId`



  useEffect(() => {
    const fetchContacts = async () => {

      try {
        const response = await callApiFunction('ConnectedContacts');

        const data = response;
        if (data.statusCode === 200) {
          const members = data.data.map(member => {
            // Logic for role and subTitle
            const role = member.designation || member.field_of_study || member.title || '---';  // Updated role logic
            const subTitle = member.profession_department || member.institute || member.nickname || '---';  // New subTitle logic

            return {
              id: member.id,
              contact_ref_id: member.contact_ref_id,
              img: member.profile_url,  // Fallback to default image if profile URL is null
              is_favourite: member?.is_favourite ? true : false,
              name: `${member.first_name} ${member.last_name}`,
              role: role,  // Based on new logic
              email: `${member.first_name.toLowerCase()}.${member.last_name.toLowerCase()}@example.com`,  // Mock email as it's not provided
              verified: member.is_verified ? true : false,
              neoin_id: member.unique_id,
              subTitle: subTitle  // Add new subTitle field
            };
          });
          setConnectedContacts(members)

          const unverifiedMembers = members.filter(member => !member.verified);
          setUnverifiedContacts(unverifiedMembers);
          setUnVerifedCount(unverifiedMembers.length);

          // Filter and set favorite contacts
          const favoriteMembers = members.filter(member => member.is_favourite);
          setFavoriteContacts(favoriteMembers);
        }
      } catch (err) {
        console.log('An error occurred while sending the connection request:', err);
      }
    }
    fetchContacts();
  }, [])

  axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;
  const [profilePicturePersonal, setprofilePicturePersonal] = useState('');
  const [SocialLinks, setSocialLinks] = useState("");
  const anySocialIconsVisible = SocialLinks && SocialLinks.links?.some(link => link && link.visible);
  const initialCardSocialLinks = {
    User_ID: objectId,
    CardType: 'Personal',
    links: [
      { network: 'linkedin', url: '', visible: false },
      { network: 'facebook', url: '', visible: false },
      { network: 'instagram', url: '', visible: false },
    ],
  }

  const [cardDetailsForPersonal, setCardDetailsForPersonal] = useState({
    User_ID: objectId,
    ProfilePicture: {
      name: '',
      type: '',
      data: ''
    },
    CompanyLogo: {
      name: '',
      type: '',
      data: ''
    },
    Designation: 'Profession',
  });

  const [ContactStyles, setContactStyles] = useState({
    User_ID: objectId,
    CardType: 'Professional',
    iconBgColor: '#0044C6',
    callNo: { input: '', visible: true },
    textNo: { input: '', visible: true },
    emailId: { input: '', visible: true },
    whatsapp: { input: '', visible: true },
    address: '',
    city: '',
    postalcode: '',
    state: '',
    country: '',
    latitude: '',
    longtitude: '',
  })

  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');

  useEffect(() => {

    const lat = parseFloat(ContactStyles.latitude);
    const lon = parseFloat(ContactStyles.longtitude);

    if (!isNaN(lat) && !isNaN(lon)) {
      setLatitude(lat);
      setLongitude(lon);
    } else {
      setLatitude(12.979871024899435);
      setLongitude(77.60654611960474);
    }
  }, [ContactStyles.latitude, ContactStyles.longtitude]);

  const initialCardDetails = {
    User_ID: objectId,
    employee_id: '',
    company_id: '',
    profession_department: '',
    profession_id: '',
    company_website: '',
    is_professional_verified: false,
    professional_details_status: '',
    student_id: '',
    student_email_id: '',
    student_year: '',
    student_ending_year: '',
    student_currently_pursuing: false,
    education_level: '',
    institute: '',
    board: '',
    degree: '',
    field_of_study: '',
    grade: '',
    is_student_verified: false,
    student_details_status: '',
    CardType: 'Personal',
    prefix: '',
    suffix: '',
    title: '',
    nickname: '',
    summary: '',
    designation: '',
    company: '',
    profession_department: '',
    profile_pic: '',
    logo: ''
  };
  const apifetching2 = useRef(false);
  useEffect(() => {
    const fetchCardDetails = async () => {
      if (apifetching2.current) return;
      apifetching2.current = true;

      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/getParticularCardInfo`, {
          params: {
            CardName: 'Personal',
            referenceId: objectId
          },
          headers: headers
        });

        // console.log('Fetched card details:', response.data);
        // if (response.data.Details.length > 0) {
        //   setCardDetails(response.data.Details[0]);
        // }
        if (response.data.Details.length > 0) {
          const details = response.data.Details[0];

          // Create a new object with renamed keys and omit the old key
          const { user_ref_id, ...restDetails } = details; // Destructure to remove user_ref_id
          const renamedDetails = {
            ...restDetails,
            User_ID: user_ref_id, // Add User_ID with the value of user_ref_id
          };

          // Set the renamed object to state
          setCardDetailsForPersonal(renamedDetails);
        }
        else {
          setCardDetailsForPersonal(initialCardDetails);
        }

      } catch (error) {
        console.error('Error fetching card details:', error);
      }

      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/get-social-links`, {
          params: {
            cardType: 'Personal',
          },
          headers: headers,
        });
        // console.log('Fetched social links:', response.data);
        // setSocialLinks(response.data);
        const transformedLinks = response.data.map((link) => ({
          network: link.info_key,
          url: link.info_value,
          visible: link.is_visible,
        }));

        // console.log('Transformed Links: ', transformedLinks)

        setSocialLinks({
          user_ref_id: objectId,
          card_type: "Personal",
          links: transformedLinks,
        });
        console.log(SocialLinks);
      } catch (error) {
        // console.error('Error fetching Social Links:', error);
        setSocialLinks(initialCardSocialLinks);
      }
    };

    fetchCardDetails();
  }, []);

  useEffect(() => {
    if (cardDetailsForPersonal.profile_pic !== null && cardDetailsForPersonal.profile_pic !== '') {
      setprofilePicturePersonal(cardDetailsForPersonal.profile_pic);
    } else {
      setprofilePicturePersonal(defaultprofile);
    }
  }, [cardDetailsForPersonal]);


  const percentage = 100;
  const [isHovered, setIsHovered] = useState(false);
  const truncateName = (name) => {
    if (name.length <= 6) {
      return name; // Return the name itself if its length is 6 or less
    } else {
      const maxLength = Math.floor(name.length / 2);
      const truncatedName = name.slice(0, maxLength) + "...";
      return truncatedName;
    }
  };

  const shouldShowTooltip = (name) => {
    return name.length > 6;
  };

  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleTooltipToggle = () => {
    setIsTooltipOpen(!isTooltipOpen); // Toggle the tooltip on click
  };


  return (
    <div className="d-flex align-items-start gap-4 p-4 home-page-container">

      <div className="homePage-section-one" ref={Column1Ref} style={{
        minHeight: `${availableHeight1}px`,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto"
      }}>
        <div className="profile-box-1">
          <p className="profile-content">Personal</p>
        </div>
        <div className="homepage-background-image rectangle-new">
          <div className="Qr-codeDesign-home flex-center">
            <QRCode
              className="container-gift-2"
              value={`${process.env.REACT_APP_CARD_URL}/digital-identity/Personal/${objectId}`}
              style={{ height: "96px", width: "96px" }}
            />
          </div>
          <div className="profile-picture-homeOutline flex-center">
            <img className="cover-image" src={profilePicturePersonal} alt="personalCard_Image" />
          </div>
        </div>

        <div className="heading mt-5 pt-4">
          <h2 className="heading mt-2">{userDetails.name}</h2>
          <span className="subheading">{userDetails.profession}</span>
          <p className="subheading">ID: 256163</p>
        </div>

        <div className="heading-content home mx-3 mb-4">
          <p className="m-0">
            Hello, I'm {userDetails.name}  UI/Visual Designer based in Bangalore. My professional journey has been marked by versatile roles in UI and Visual Design.
          </p>
        </div>

        <div className="my-profile-actions" style={{ marginBottom: "44px" }}>
          <div className="flex-center">
            <div className="probar">
              <CircularProgressbarWithChildren
                value={percentage}
                styles={buildStyles({
                  pathColor: `#FFA000`,
                  trailColor: `#FFDDA4`,
                  textColor: `#525252`,
                  textSize: `10px`,
                })}
              >
                <div style={{ fontSize: "10px", marginBottom: "5px" }}>
                  Status
                </div>

                <div style={{ fontSize: "10px", marginBottom: "5px" }}>
                  {percentage} %
                </div>
              </CircularProgressbarWithChildren>
            </div>
            <div className="col probar-content">
              <h3 className="tit">Profile Completion</h3>
              <p className="tit-cont">
                {percentage === 100 ? (
                  <>
                    Well Done! Your Profile is completed.
                  </>
                ) : (
                  <>
                    Uh-oh! Looks like your profile and <br />{" "}
                    <u>
                      <a href="#0">KYC</a>
                    </u>{" "}
                    need some attention for a verified ID.
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="homePage-section-two justify-content-between gap-2" style={{
        display: "flex",
        flexDirection: "column",
        minHeight: `${availableHeight1}px`,
        overflow: "hidden",
      }}>
        <div className="sec-box-heightCommon p-3">
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <p className="card-title mt-0">No. of cards</p>
              <p className="count-value mb-2">{cards.length + groupCardDetails.length}</p>
            </div>
            <div>
              <img src={cardimg} alt="cardimg" />
            </div>
          </div>

          <div className="d-flex">
            <div className="col">
              <p className="count-title m-0">Active</p>
              <p className="count-cont m-0">650</p>
            </div>
            <div className="col">
              <p className="count-title m-0">Inactive</p>
              <p className="count-cont-1 m-0">56</p>
            </div>
          </div>

        </div>
        <div className="home-sec-middlePart d-flex" style={{ flexGrow: 1 }}>
          <div className="home-row d-flex flex-column h-100">
            <div className="col side-box-1 icon-container">
              <LocalPhoneRoundedIcon />
            </div>
            <div className="col side-box-1 icon-container">
              <ForumRoundedIcon />
            </div>
            <div className="col side-box-1 icon-container">
              <VideoChatRoundedIcon />
            </div>
            <div className="col side-box-1 icon-container">
              <AlternateEmailRoundedIcon />
            </div>
            <div className="col side-box-1 icon-container">
              <img src={whatsapp} alt="whatsapp" />
            </div>
          </div>

          <div>
            <p className="card-title ms-3 mt-3 mb-2">Communication Channel</p>
            <div className="social-icons-container-homePage w-100">
              {anySocialIconsVisible && (
                <div className="social-icons-rows d-flex flex-wrap">
                  {SocialLinks.links.map((link) => (
                    link.visible && (
                      <a key={link.network} href={link.url} target="_blank" rel="noopener noreferrer">
                        <div className="square-box-32px flex-center">
                          {/* Get the icon using getIconAndLabel */}
                          {(() => {
                            const { icon: Icon } = getIconAndLabel(link.network);
                            return Icon ? <Icon className="social-icon svg-icon-32px" /> : null;
                          })()}
                        </div>
                      </a>
                    )
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="sec-box-heightCommon d-flex p-3">
          <div>
            <div className="card-title">Calendar</div>
            <div className="date-count">10</div>
            <div className="count-title-1 text-nowrap"> Wed Apr 2024</div>
          </div>

          <div className="d-flex flex-column align-items-end">
            <div className="img-container">
              <img src={calendar} alt="calendar" />
            </div>
            <div className="calendar-cont">
              <div className="calendar-title text-end">Today's Events</div>
              <div className="calendar-content text-end">Product mockup scheduled</div>
            </div>
          </div>
        </div>
      </div>


      <div className="justify-content-between gap-2" style={{
        flexGrow: 1, height: "615px",
        display: "flex",
        flexDirection: "column",
        minHeight: `${availableHeight1}px`,
        overflowY: "auto",
      }}>
        <div className="sec-lastRow-height d-flex gap-2 justify-content-between">
          <div className="smallBox p-3" style={{ flexGrow: 1 }}>
            <p className="card-title mb-1 mt-0">Favourite Contacts</p>
            {Array.isArray(favouriteContacts) && (
              <>
                <div className="d-flex flex-wrap align-items-center justify-content-start gap-2">
                  {favouriteContacts.length > 0 ? (
                    <>
                      {favouriteContacts.slice(0, 6).map((person, idx) => (
                        <Avatar
                          sx={{ width: 32, height: 32 }}
                          key={idx}
                          alt={person.name}
                          src={person.img} >
                          {person.name.charAt(0).toUpperCase()}
                        </Avatar>
                      ))}
                    </>
                  ) : (
                    <div className="no-contacts-message">
                      No Favourite Contacts
                    </div>
                  )}
                </div>
              </>
            )}

          </div>
          <div className="smallBox p-3" style={{ flexGrow: 1 }}>
            <p className="card-title mb-1 mt-0">Active Contacts</p>
            {Array.isArray(ConnectedContacts) && (
              <>
                <div className="d-flex align-items-center justify-content-start gap-2 flex-wrap">
                  {ConnectedContacts.length > 0 ? (
                    <>
                      {ConnectedContacts.slice(0, 6).map((person, idx) => (
                        <Avatar
                          sx={{ width: 32, height: 32 }}
                          key={idx}
                          alt={person.name}
                          src={person.img} >
                          {person.name.charAt(0).toUpperCase()}
                        </Avatar>
                      ))}
                    </>
                  ) : (
                    <div className="no-contacts-message">
                      No Connected Contacts
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="home-sec-middlePart p-2" style={{ flexGrow: 1 }}>
          {(latitude !== null && latitude != '') && (longitude !== null && longitude != '') && (
            <MapIntegration style={{ borderRadius: "6px" }} latitude={latitude} longitude={longitude} />
          )}
        </div>

        <div className="sec-box-heightCommon d-flex flex-column p-3">
          <div className="flex-center-between">
            <div className="d-flex gap-1">
              <div className="note-icon">
                <StickyNote2RoundedIcon />
              </div>
              <p className="card-title m-0">Note</p>
            </div>
            <div className="note-subicon status">
              <NotificationAddRoundedIcon />
              <ShareRoundedIcon />
            </div>
          </div>
          <p className="dateline text-start mt-1 mb-2">Wed Apr 10 2024</p>
          <p className="dateline text-starts mt-1 mb-2">
            Next Week events are scheduled, need to plan for the Rollup
          </p>

          <Tooltip className="profile-box d-flex align-items-center justify-content-start" title={userDetails.name} arrow>
            <Chip
              className="d-flex align-items-center justify-content-start"
              avatar={<Avatar alt="Avatar" src={userDetails.proFile} />}
              label={
                <TruncatedLabel>
                  {userDetails.name}
                </TruncatedLabel>
              }
              variant="outlined"
            />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

// Styled Chip to handle text truncation
const TruncatedLabel = styled('span')({
  maxWidth: '100px',
  height: '35px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center'
});

export default HomePage;


